export class Confirmation {
  constructor(public message: string, public state = false) {}

  static confirmed(): Confirmation {
    return new Confirmation('', true);
  }

  static rejected(): Confirmation {
    return new Confirmation('', false);
  }

  public confirm(): void {
    this.state = true;
  }
}
